import { ProductUnknown } from "@/common/contracts/product.contracts";
import { useCallback, useEffect, useState } from "react";
import { GUEST_CHECKOUT_KEY } from "common/static/checkout/checkout.static";

const isBrowser = () => typeof window !== "undefined";

export const useProductIsInCart = (product?: ProductUnknown) => {
  /** We use state instead of a memo to avoid hydration issues. */
  const [isInCart, setIsInCart] = useState(false);

  const checkIsInCart = useCallback((product?: ProductUnknown) => {
    if (!isBrowser() || !product) {
      setIsInCart(false);
      return;
    }

    if (product.isInCart) {
      setIsInCart(true);
      return;
    }

    const checkoutProductIdsString = localStorage.getItem(GUEST_CHECKOUT_KEY);

    const checkoutProductIds = checkoutProductIdsString
      ? JSON.parse(checkoutProductIdsString)
      : [];

    setIsInCart(checkoutProductIds.includes(product.id));
  }, []);

  useEffect(() => {
    checkIsInCart(product);
  }, [checkIsInCart, product]);

  return { checkIsInCart, isInCart };
};
